import { Component, OnInit } from "@angular/core";
import { CommonService } from "src/app/core/services/common.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { TokenService } from "src/app/core/services/token.service";
import { DescargaFicheroConcesionarioService } from "../descarga-fichero-concesionario.service";

@Component({
  selector: "app-descarga-fichero-concesionario-download",
  templateUrl: "./descarga-fichero-concesionario-download.component.html",
  styleUrls: ["./descarga-fichero-concesionario-download.component.scss"],
})
export class DescargaFicheroConcesionarioDownloadComponent {
  constructor(
    private descargaFicheroConcesionarioService: DescargaFicheroConcesionarioService,
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService,
    private tokenService: TokenService
  ) {}

  descargaDoc() {
    this.sweetAlertService.sweetAlertLoading();
    this.descargaFicheroConcesionarioService.getFile().subscribe(
      (data) => {
        this.commonService.downloadFile(data, "concesionarios.xls");
        this.toastrAlertService.toastrSuccess("Archivo descargado");
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastFailBlob(err.error);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
